import Parse from "parse";

export const checkPartner = async (quizCode, userRole, introInCode) => {
  const partnerRole = userRole === "agentX" ? "agentY" : "agentX";

  const GameUser = Parse.Object.extend("spyx");
  const query = new Parse.Query(GameUser);
  query.equalTo("introInCode", introInCode);
  query.equalTo("userRole", partnerRole);

  const partners = await query.find();

  // 디버깅 코드
  // console.log("📌 quizCode", quizCode);
  // console.log("📌 userRole", userRole, "→ partnerRole", partnerRole);
  // console.log("📌 introInCode", introInCode);
  // console.log("📌 partners", partners);
  // console.log("📌 partners 수", partners.length);
  // partners.forEach((p, i) => {
  //   console.log(`📌 partner[${i}] clearedQuiz`, p.get("clearedQuiz"));
  // });

  if (partners.length === 0) return false;

  return partners.every((p) => {
    const clearedQuiz = p.get("clearedQuiz") ?? [];

    return clearedQuiz.includes(quizCode);
  });
};
